<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	{height}
	{width}
	class={className}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M12 4C8.27754 3.99952 5.04663 6.5666 4.20575 10.1928C3.36487 13.8191 5.13623 17.5461 8.479 19.184C8.64686 19.2662 8.75487 19.4351 8.759 19.622C8.80837 20.8317 9.52972 21.9124 10.628 22.422C10.8529 22.527 10.9975 22.7518 11 23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23C13.0002 22.7491 13.1456 22.521 13.373 22.415C14.4719 21.9021 15.1942 20.8205 15.247 19.609C15.2542 19.4256 15.3613 19.261 15.526 19.18C18.8649 17.5394 20.6321 13.8137 19.7904 10.19C18.9487 6.56626 15.7202 4.00098 12 4ZM10 12.5C10 12.6381 9.88807 12.75 9.75 12.75H9.25C8.83579 12.75 8.5 12.4142 8.5 12C8.5 11.5858 8.83579 11.25 9.25 11.25C9.66421 11.25 10 11.5858 10 12V12.5ZM12 17.979C12.2761 17.979 12.5 17.7551 12.5 17.479V14.751C12.5 14.4749 12.2761 14.251 12 14.251C11.7239 14.251 11.5 14.4749 11.5 14.751V17.479C11.5 17.7551 11.7239 17.979 12 17.979ZM14.348 17.522C14.2705 17.5541 14.1822 17.5458 14.112 17.5C14.0422 17.4542 14.0001 17.3764 14 17.293V14.751C14 14.4749 14.2239 14.251 14.5 14.251H14.75C15.9925 14.251 16.9998 13.2438 17 12.0013C17.0002 10.7588 15.9932 9.75137 14.7507 9.751C13.5082 9.75063 12.5006 10.7575 12.5 12V12.25C12.5 12.5261 12.2761 12.75 12 12.75C11.7239 12.75 11.5 12.5261 11.5 12.25V12C11.5 10.7574 10.4926 9.75 9.25 9.75C8.00736 9.75 7 10.7574 7 12C7 13.2426 8.00736 14.25 9.25 14.25H9.5C9.77614 14.25 10 14.4739 10 14.75V17.292C10.0002 17.3758 9.95808 17.454 9.888 17.5C9.81797 17.5464 9.72939 17.5546 9.652 17.522C7.02835 16.4052 5.55315 13.5961 6.12306 10.8022C6.69297 8.00823 9.15054 6.00136 12.002 6.00136C14.8535 6.00136 17.311 8.00823 17.8809 10.8022C18.4508 13.5961 16.9756 16.4052 14.352 17.522H14.348ZM14.75 11.25C14.3358 11.25 14 11.5858 14 12V12.5C14 12.6381 14.1119 12.75 14.25 12.75H14.75C15.1642 12.75 15.5 12.4142 15.5 12C15.5 11.5858 15.1642 11.25 14.75 11.25Z"
		fill="currentColor"
	/>
	<path
		d="M2 11H1C0.447715 11 0 11.4477 0 12C0 12.5523 0.447715 13 1 13H2C2.55228 13 3 12.5523 3 12C3 11.4477 2.55228 11 2 11Z"
		fill="currentColor"
	/>
	<path
		d="M4.222 5.637C4.61438 6.01597 5.23809 6.01055 5.62382 5.62482C6.00956 5.23908 6.01498 4.61538 5.636 4.223L4.929 3.516C4.53662 3.13703 3.91292 3.14245 3.52718 3.52818C3.14145 3.91391 3.13603 4.53762 3.515 4.93L4.222 5.637Z"
		fill="currentColor"
	/>
	<path
		d="M12 3C12.5523 3 13 2.55228 13 2V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V2C11 2.55228 11.4477 3 12 3Z"
		fill="currentColor"
	/>
	<path
		d="M19.071 3.516L18.364 4.223C18.104 4.47407 17.9998 4.84588 18.0913 5.19551C18.1828 5.54514 18.4559 5.81818 18.8055 5.9097C19.1551 6.00121 19.5269 5.89696 19.778 5.637L20.485 4.93C20.864 4.53762 20.8586 3.91391 20.4728 3.52818C20.0871 3.14245 19.4634 3.13703 19.071 3.516Z"
		fill="currentColor"
	/>
	<path
		d="M23 11H22C21.4477 11 21 11.4477 21 12C21 12.5523 21.4477 13 22 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11Z"
		fill="currentColor"
	/>
	<path
		d="M19.778 18.366C19.5269 18.106 19.1551 18.0018 18.8055 18.0933C18.4559 18.1848 18.1828 18.4579 18.0913 18.8075C17.9998 19.1571 18.104 19.5289 18.364 19.78L19.071 20.487C19.4634 20.866 20.0871 20.8605 20.4728 20.4748C20.8586 20.0891 20.864 19.4654 20.485 19.073L19.778 18.366Z"
		fill="currentColor"
	/>
	<path
		d="M4.222 18.366L3.515 19.073C3.25504 19.3241 3.15079 19.6959 3.2423 20.0455C3.33382 20.3951 3.60686 20.6682 3.95649 20.7597C4.30612 20.8512 4.67792 20.747 4.929 20.487L5.636 19.78C6.01497 19.3876 6.00955 18.7639 5.62382 18.3782C5.23808 17.9924 4.61438 17.987 4.222 18.366Z"
		fill="currentColor"
	/>
</svg>
